import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BlankFormBatchSearchEngineReducer } from '../reducers';

export const selectBlankFormBatchSearchEngineFeature = createFeatureSelector<BlankFormBatchSearchEngineReducer.BlankFormBatchSearchEngineState>(BlankFormBatchSearchEngineReducer.featureName);

export const selectItem = createSelector(selectBlankFormBatchSearchEngineFeature, state => state.item);
